import VideoPlayer from "../video-player/video-player";
import { parseTrsMetadata } from "./parseTrsMetadata";

export interface VideoViewerProps {
    url: string;
    mediaType: string;
}

export const VideoViewer = ({ url: citationPath, mediaType }: VideoViewerProps) => {
    const metadata = parseTrsMetadata(citationPath);
    if (!metadata) {
        console.error("Invalid .trs file format:", citationPath);
        return <div>Error: Invalid .trs file format</div>;
    }
    return (
        <div>
            <VideoPlayer
                id="player1"
                publicId={metadata.id}
                offsetSecs={metadata.offsetSecs}
                sourceConfig={{
                    sourceTypes: [mediaType == "video" ? "hls" : "audio"],
                    info: { title: "" }
                }}
            />
        </div>
    );
};
